import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ModalComponent } from 'src/app/shared/components/modal/modal.component';
import { ForgotPasswordService } from './forgot-password.service';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
  forgetPasswordForm: FormGroup;
  errorMsg: string = null;
  dialogConfig = new MatDialogConfig();

  constructor(
    private fb: FormBuilder,
    private fgService: ForgotPasswordService,
    private gobalFunctionService: GobalFunctionService,
    public matDialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.forgetPasswordForm = this.fb.group({
      email: ['', [Validators.required, Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$")]],
    })
    this.gobalFunctionService.setSEO('ลืมรหัสผ่าน', 'website', '');
  }

  resetPassword() {
    this.fgService.changePassword(this.forgetPasswordForm.get('email').value).subscribe((res) => {
      this.errorMsg = null;
      this.dialogConfig.disableClose = true;
      this.dialogConfig.id = "modalConfirm";
      this.dialogConfig.data = {
        name: "confirm",
        description: res.message,
        cancleBtnText: "ตกลง",
      }
      this.matDialog.open(ModalComponent, this.dialogConfig);
    }, err => {
      this.errorMsg = err.error.message;
    });
  }
}
